/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ElectRoleFiller_change$ref = any;
type LinkedRole_change$ref = any;
type MoveItems_change$ref = any;
type Policy_change$ref = any;
type Policy_proposal$ref = any;
type Role_change$ref = any;
type Role_proposal$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type ChangeList_proposal$ref: FragmentReference;
declare export opaque type ChangeList_proposal$fragmentType: ChangeList_proposal$ref;
export type ChangeList_proposal = {|
  +id: string,
  +hasConflicts: boolean,
  +changes: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +type: string,
        +$fragmentRefs: LinkedRole_change$ref & Role_change$ref & Policy_change$ref & MoveItems_change$ref & ElectRoleFiller_change$ref,
      |}
    |}>
  |},
  +$fragmentRefs: Policy_proposal$ref & Role_proposal$ref,
  +$refType: ChangeList_proposal$ref,
|};
export type ChangeList_proposal$data = ChangeList_proposal;
export type ChangeList_proposal$key = {
  +$data?: ChangeList_proposal$data,
  +$fragmentRefs: ChangeList_proposal$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "changes"
        ]
      }
    ]
  },
  "name": "ChangeList_proposal",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasConflicts",
      "storageKey": null
    },
    {
      "alias": "changes",
      "args": null,
      "concreteType": "DescribeChangeableConnection",
      "kind": "LinkedField",
      "name": "__ChangeList_changes_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DescribeChangeableEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "LinkedRole_change"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "Role_change"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "Policy_change"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "MoveItems_change"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ElectRoleFiller_change"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Policy_proposal"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Role_proposal"
    }
  ],
  "type": "Proposal",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '20a173ff749bfb2ce3876a2ffba3b16b';

module.exports = node;
